import { takeLatest, put, call } from 'redux-saga/effects';
import { SEND_MAIL, RESEND_MAIL, RESEND_MAIL_SUCESS } from './types';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { sendMail, resendMail } from './../../network/mail';
import { STATUS } from '../../config/constants/states';

function* sendMailSengrid(action) {
  const payload = action.payload;
  const { email, paymentData } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendMail, email, paymentData);
    sessionStorage.removeItem('ownerMail');
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* requestResendMail(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(resendMail, payload);
    yield put({ type: RESEND_MAIL_SUCESS, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    const { status, data } = e.response;
    yield put({ type: RESEND_MAIL_SUCESS, payload: STATUS.ERROR });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* watchSendMail() {
  yield takeLatest(SEND_MAIL, sendMailSengrid);
}

function* watchReSendMail() {
  yield takeLatest(RESEND_MAIL, requestResendMail);
}

export default [
  watchSendMail(),
  watchReSendMail(),
];

